<ngx-smart-modal [customClass]="'msg-modal'" #myModal identifier="myModal" [closable]="false" [dismissable]="false" [escapable]="false">
  <form [formGroup]="userForm" novalidate>
    <div class="modal-header">
      Add Authorizer
    </div>
    <common-alerts [error]="userFormErrors"></common-alerts>
    <div style="padding: 16px">
      <div *ngIf="!formSubmitted">
        <div class="header-helper">
          Provide the email address and name of the new authorizer. They will be emailed an invitation to create an account in this system. After they accept the invitation you
          will
          be
          able to enroll them to manage this domain.
        </div>
        <div>
          <label>
            <input type="text" placeholder="Email" formControlName="email" size="100" maxlength="100"
                   id="userFormEmail"/>
          </label>
          <div class="form-error is-visible" *ngIf="displayValidationError('email')">
            <div *ngIf="userForm.controls.email.invalid" style="color: red">
              Invalid Email
            </div>
          </div>
          <label>
            <input type="text" placeholder="First Name" formControlName="firstName" size="100" maxlength="100"/>
            <lib-whitelist-character-error [whitelistFormControl]="firstName"></lib-whitelist-character-error>
          </label>
          <label>
            <input type="text" placeholder="Last Name" formControlName="lastName" size="100" maxlength="100"/>
            <lib-whitelist-character-error [whitelistFormControl]="lastName"></lib-whitelist-character-error>
          </label>
        </div>

        <div class="header-helper">
          By submitting this personal data, you acknowledge that the personal data will be processed in accordance with
          the <a target="_blank" href="https://www.icann.org/privacy/policy">ICANN Privacy Policy</a> and agree to comply with the
          <a target="_blank" href="https://www.icann.org/privacy/tos">ICANN Terms of Service</a>.
        </div>
        <div class="save-cancel-button-group">
          <button class="iana-button-cancel" (click)="close()">Cancel</button>
          <button class="iana-button" [disabled]="!userForm.valid" (click)="userFormSubmit()" type="submit">Proceed</button>
        </div>
      </div>

      <div *ngIf="formSubmitted" class="header-helper">
        <div *ngIf="foundUser && ['EXPIRED'].includes(this.foundUserValue.status)">
          <p>User {{foundUserValue.firstName}} {{foundUserValue.lastName}} ({{foundUserValue.email}}) has been previously invited, but has not yet created an RZM account.</p>
          <p>To resend the invitation and create a change request to add them as an authorizer, click "Add".</p>
          <p>To select a different user, click "Cancel."</p>
        </div>

        <div *ngIf="foundUser && ['INVITED'].includes(this.foundUserValue.status)">
          <p>An invitation has already been sent to {{foundUserValue.firstName}} {{foundUserValue.lastName}} ({{foundUserValue.email}}) to create an RZM account.</p>
          <p>To create a change request to add them as an authorizer, click "Add"</p>
          <p>To select a different user, click "Cancel."</p>
        </div>

        <div *ngIf="foundUser && ['ACCEPTED', 'VERIFIED'].includes(this.foundUserValue.status)">
          <p>{{foundUserValue.firstName}} {{foundUserValue.lastName}} ({{foundUserValue.email}}) is an existing RZMS user.</p>
          <p>To create a change request to add them as an authorizer, click "Add"</p>
          <p>To select a different user, click "Cancel".</p>
        </div>

        <div *ngIf="!foundUser">
          <p>No user with the email address {{userForm.getRawValue().email}} exists.</p>
          <p>Adding this user will generate both an invitation for them to create an RZM account and a change request to add them as an authorizer.</p>
          <p>If you would like to add a different user, click "Cancel".</p>
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center">
          <a class="a-link" (click)="goBack()"><< Back</a>
          <div class="save-cancel-button-group">
            <button class="iana-button-cancel" type="reset" (click)="close()">Cancel</button>
            <button class="iana-button" (click)="proceed()">Add</button>
          </div>
        </div>

      </div>
    </div>
  </form>
</ngx-smart-modal>
